import Vue from 'vue'
import App from './App'
// import Axios from 'axios'
import router from '@/router'
import store from '@/store'
import filters from '@/filters'
import directives from '@/directives'
import EventBus from './utils/EventBus'
import MessagePlugin from 'gkui/message/index'
// import ViewUI from 'view-design'
import VConsole from 'vconsole'

// import timesdk from 'timesdk'
import { DatePicker, Rate } from 'view-design'
import 'view-design/dist/styles/iview.css'

import CommonLogin from './components/modal/login'
// import CommonLogin from 'infoqElement/login' // 先不用扫码登录  扫码登录会提示离开

process.env.NODE_ENV === 'development' && new VConsole()

Vue.component('DatePicker', DatePicker)
Vue.component('Rate', Rate)

// Vue.use(ViewUI)
Vue.use(MessagePlugin)
Vue.use(EventBus)
// Vue.use(timesdk)
// 注册全局登录注册框
Vue.use(CommonLogin, {
  theme: 'blue'
})
// 设置过滤器
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))

// 设置自定义指令
Object.keys(directives).forEach(k => Vue.directive(k, directives[k]))

/* eslint-disable no-new */
new Vue({
  router,
  store,
  created () {},
  render: h => h(App)
}).$mount('#app')
